/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.sd = {};
    Blockly.Blocks.sd.style = 'sd_blocks';
    Blockly.Blocks.sd_init = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput().appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_BEGIN + " (SPI)").appendField(Blockly.Msg.SD_PIN + " CS")
                .appendField(new Blockly.FieldDropdown(profile["default"].digital),
                "CS");
            this.setPreviousStatement(!0, null);
            this.setInputsInline(!0);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.sd_print = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput().appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_FILE);
            this.appendValueInput("FILE", "String")
                .setAlign(Blockly.ALIGN_RIGHT)
            this.appendValueInput("STRINGOUTPUT","String")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.SD_WRITE);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldCheckbox("TRUE"), "NEWLINE")
                .appendField(Blockly.Msg.SD_ADD_NEW_LINE);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.sd_filesize = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_SIZE);
            this.appendValueInput("FILE", "String")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!1, null);
            this.setInputsInline(!0);
            this.setNextStatement(!1, null);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.sd_readbyte = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_READBYTE);
            this.appendValueInput("FILE", "String")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.appendValueInput("POS", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.SD_POS);
            this.setInputsInline(!0);
            this.setPreviousStatement(!1, null);
            this.setNextStatement(!1, null);
            this.setOutput(!0, "Number");
        }
    };
    Blockly.Blocks.sd_readloop = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_READLOOP);
            this.appendValueInput("FILE", "String")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.appendDummyInput()
                .appendField(new Blockly.FieldVariable(null, null, ['Number'], 'Number'), "VAR")
            this.appendStatementInput("DO")
                .appendField(Blockly.Msg.SD_DO);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        },
        customContextMenu: function(options) {
            if (this.isInFlyout) {
                return;
              }
            var variable = this.getField('VAR')
                               .getVariable();
            var varName = variable.name;
            if (!this.isCollapsed() && varName != null) {
                var option = {enabled: true};
                option.text = 
                    Blockly.Msg.VARIABLES_SET_CREATE_GET.replace("%1", varName);
                var xmlField = Blockly.Variables.generateVariableFieldDom(variable);
                var xmlBlock = Blockly.utils.xml.createElement('block');
                xmlBlock.setAttribute('type', 'variables_get_number');
                xmlBlock.appendChild(xmlField);
                option.callback = Blockly.ContextMenu.callbackFactory(this, xmlBlock);
                options.push(option);
            }
        }
    };
    Blockly.Blocks.sd_writebyte = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_WRITEBYTE);
            this.appendValueInput("FILE", "String")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.appendValueInput("BYTE", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.sd_remove = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput().appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_REMOVE);
            this.appendValueInput("FILE", "String").setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.sd_exists = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(Blockly.Msg.SD_EXISTS);
            this.appendValueInput("FILE", "String").setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setOutput(!0, "Boolean")
        }
    };
    Blockly.Blocks.sd_format = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.sd.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.SD);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/sd.svg", 45, 45))
                .appendField(
                    new Blockly.FieldDropdown([
                      [Blockly.Msg.SD_FORMAT, "F"],
                      [Blockly.Msg.SD_FORMAT_QUICK, "Q"],
                      [Blockly.Msg.SD_ERASE, "E"],
                    ]),
                    "MODE"
                  );
            this.setInputsInline(true);
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null)
        }
    };

}